<div class="mb-3" [class.invalid-feedback]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id">
    {{ props.label }}
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div>
    <ng-select [items]="selOptions"
               [formControl]="formControl"
               [virtualScroll]="true"
               [loading]="loading"
               [closeOnSelect]="false"
               [multiple]="true"
               [selectableGroup]="true"
               placeholder="Поиск каталогов"
               (scroll)="onScroll($event)"
               (scrollToEnd)="onScrollToEnd()"
               bindLabel="header"
               i18n-placeholder="@CatalogsSearch"
               bindValue="id"
    >
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
        <span [title]="item.header" [innerHTML]="item.header" style="white-space: pre; color: inherit;"></span>
      </ng-template>

    </ng-select>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
